module.exports = __webpack_public_path__ + "img/201219_TUTORIAL-05.edc5e44d.jpg";